import { render, staticRenderFns } from "./mobileCommonDialog.vue?vue&type=template&id=630964aa&scoped=true"
import script from "./mobileCommonDialog.vue?vue&type=script&lang=js"
export * from "./mobileCommonDialog.vue?vue&type=script&lang=js"
import style0 from "./mobileCommonDialog.vue?vue&type=style&index=0&id=630964aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630964aa",
  null
  
)

export default component.exports